(function(){
    'use strict'

    angular
    .module('app.categorias')
    .controller('categorias.Edit', Edit);

    Edit.$inject = ['$q', '$scope', '$animationsSrv', '$routeParams','ApiBaseService', 'logger', '$location', 'UserInfoService', 'moment'];

    function Edit($q, $scope, $animationsSrv, $routeParams, ApiBaseService, logger, $location, UserInfoService, moment) {
    
        $animationsSrv.scrollToTop();
        const apiCategorias = 'api/Categorias';

        let vm = this;

        vm.data = {
            id: 0,
            nombre: '',
            edadInicial: null,
            edadFinal: null
        };

        vm.title = 'Categorias';
        vm.id = $routeParams.id ? $routeParams.id : 0;

        vm.uiData = {
        };

        get();

        function get(){

            if(vm.id != 0){
                ApiBaseService.remoteController = apiCategorias;
                var promise = ApiBaseService.getAll([vm.id]);

                promise
                .then(function(data){
                    vm.data = data;
                })
                .catch(function(error){
                    switch (error.status) {
                        case 401:
                            logger.error('La sesión ha expirado');
                            break;
                    
                        default:
                            logger.error('Hubo un error al obtener el registro: ' + error.data.Message);
                            break;
                    }
                });               
            }
        };

        vm.save = function(){

            $scope.submitted = true;

            if($scope.dataForm.$valid){
                if(!vm.data.id){
                    create();
                }
                else if($scope.dataForm.$dirty){
                    update();
                }
                else{
                    logger.info('No has modificado ningún dato!');
                }
            }     
        
        };

        function create() {
            ApiBaseService.remoteController = apiCategorias;
            var promise = ApiBaseService.save(vm.data);
            
            promise
            .then(function(response){
                logger.success('Registro creado con éxito.');
                clearData();
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al crear el registro: ' + error.data.Message);
                        break;
                }
            });   
        };

        function update(){
            ApiBaseService.remoteController = apiCategorias;
            var promise = ApiBaseService.update(vm.data);
            
            promise
            .then(function(response){
                logger.success('Registro modificado con éxito.');
                $location.path('/categorias');
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al modificar el registro: ' + error.data.Message);
                        break;
                }
            });   
        };

        function clearData(){
            $scope.submitted = false;
            // Reset the form model.
            vm.data = {
                id: 0,
                nombre: '',
                edadInicial: null,
                edadFinal: null
            };
            // Set back to pristine.
            $scope.dataForm.$setPristine();
            // Since Angular 1.3, set back to untouched state.
            $scope.dataForm.$setUntouched();
        };

    }
})();